import React from "react";
import { Switch } from "@material-ui/core";

export const notificationDefault = {
  open: false,
  message: "",
  type: "",
};

export const pageableDTODefault = {
  pageNumber: 0,
  pageSize: 30,
  sortDir: "ASC",
  sortField: "nome",
};

export const columns = [
  {
    Header: "Nome",
    getValue: (tag) => tag.nome,
    props: { component: "th", scope: "row" },
    field: "nome",
  },
  {
    Header: "Cor",
    getValue: (tag) => (
      <div
        style={{
          width: 20,
          height: 20,
          backgroundColor: tag.cor,
          borderRadius: 4,
          border: "1px solid #ccc",
        }}
      />
    ),
    props: { component: "th", scope: "row" },
    field: "cor",
  },
  {
    Header: "Status",
    getValue: (tag, index) => {
      return <Switch id={`cfg-tag-swt-sta-${index}`} checked={tag.ativo} color="primary" />;
    },
    props: { component: "th", scope: "row" },
  },
];

export const tagDefault = {
  nome: "",
  cor: "#EF4444",
  ativo: true,
};